<template>
  <div
    class="container lang-dir"
    style="
      border-bottom: 1px solid #dedede;
      background: #fff;
      padding-bottom: 15px;
    "
  >
    <PersonalAreaFormInput :title="$t('userContactDetails.email')">
      <input tabindex="8" class="p-edit" v-model="mail" @input="errors = []" />
    </PersonalAreaFormInput>
    <div v-if="!mail && !$store.state.user.email" class="miss-mail-msg">
      <p>
        <b>{{ $t("personalArea.yourMailMissToUs") }}</b>
      </p>
      <p>{{ $t("personalArea.wePromiseNotPublish") }}</p>
    </div>
    <PersonalAreaFormInput :title="$t('personalArea.subject')">
      <select
        v-model="subject"
        class="combo"
        style="height: 30px"
        @change="errors = []"
      >
        <option>{{ $t("personalArea.subjects.s1") }}</option>
        <option>{{ $t("personalArea.subjects.s2") }}</option>
        <option>{{ $t("personalArea.subjects.s3") }}</option>
        <option>{{ $t("personalArea.subjects.s4") }}</option>
      </select>
      <!-- <input tabindex="8" class="p-edit" v-model="house_number" /> -->
    </PersonalAreaFormInput>

    <PersonalAreaFormInput>
      <textarea
        tabindex="11"
        class="p-edit"
        v-model="content"
        @input="errors = []"
      />
    </PersonalAreaFormInput>
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div v-show="showSaveMailCheckbox" class="update-mail-container">
        <input
          type="checkbox"
          id="updatemail"
          v-model="updateMail"
          name="updatemail"
          checked
          class="update-mail"
        />
        <label for="updatemail"
          >{{ $t("personalArea.updateMyMail1") }}<br />
          {{ $t("personalArea.updateMyMail2") }}{{ mail }}</label
        >
      </div>
      <div v-for="error in errors" :key="error" class="error">
        {{ error }}
      </div>
      <button class="btn" @click="sendEmail">
        {{ $t("userContactDetails.send") }}
      </button>
    </div>
  </div>
</template>

<script>
import PersonalAreaFormInput from "./PersonalAreaFormInput.vue";
import * as userSendEmail from "@/services/userSendEmail.js";
import menuService from "@/services/menu";
import { mapGetters } from "vuex";
export default {
  components: { PersonalAreaFormInput },
  mounted() {
    this.mail = this.$store.state.user.email;
  },
  methods: {
    async sendEmail() {
      //validation
      this.errors = [];

      if (this.content == "" || this.mail == "")
        this.errors.push(this.$t("userContactDetails.requiredError"));

      if (this.errors.length > 0) {
        return;
      }

      let content =
        this.$t("userContactDetails.clientName") +
        ": " +
        this.$store.state.user.fullname +
        "\n";

      if (this.$store.state.user.stickerId) {
        content += "מספר מדבקה: " + this.$store.state.user.stickerId + "\n\n";
      }
      if (this.$store.state.user.clientId) {
        content +=
          "מספר לקוח בתוכנת הלקוחות: " +
          this.$store.state.user.clientId +
          "\n\n";
      }
      if (globalThis.SERVER_MODE == "online") {
        content += "שם משתמש: " + this.$store.state.user.username + "\n\n";
      }

      if (this.mail) {
        content += this.mail + "\n\n";
      }
      content += this.subject + "\n\n" + this.content + "\n\n";
      content += "\n\nהאם לעדכן את המייל שלי : ";
      content += this.updateMail ? "כן" : "לא";

      let type = "CONTACT";
      let contactDetails = {
        content,
        type,
      };
      let message = "";
      let messtype = "";
      try {
        if (await userSendEmail.postUserSendSystemEmail(contactDetails)) {
          message = this.$t("general.sendSuccess");
          messtype = "success";
        } else {
          message = this.$t("general.sendError");
          messtype = "error";
        }
      } catch (ex) {
        message = this.$t("general.sendError");
        messtype = "error";
      }
      const notification = {
        type: messtype,
        message,
        timeout: 2000,
      };
      this.$notify(notification);
      // menuService.closeMenu();
    },
  },
  computed: {
    ...mapGetters("user", ["getUserContactDeatils"]),
    showSaveMailCheckbox() {
      return (!this.$store.state.user.email && this.mail) ||
        (this.$store.state.user.email &&
          this.mail &&
          this.mail != this.$store.state.user.email)
        ? true
        : false;
    },
  },
  data() {
    return {
      subject: "",
      mail: "",
      content: "",
      updateMail: false,
      errors: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.p-edit {
  min-height: 23px;
  width: 100%;
  border-width: 0px;
  background: transparent;
}
.container {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.container * {
  // padding: 0px;
  margin: 0px;
}
.miss-mail-msg {
  color: #a7610f;
  padding-top: 6px;
  font-size: 11px;
  line-height: 120%;

  top: -11px;
  position: relative;
}
.update-mail {
  opacity: 1;
  width: 10px;
  height: 10px;
  position: relative;
  top: 3px;
}
.update-mail-container {
  line-height: 120%;
  opacity: 1;
  display: flex;
  align-items: top;
  gap: 5px;
}
.combo {
  border-radius: 5px;
  border: 1px solid #e2e1e5;
  background: #ebebeb;
  display: flex;
  padding: 7px 10px;
  margin: 0px;
  padding: 0px;
  width: 100%;
  padding: 0px 10px;
}
.error {
  color: red;
}
</style>
